import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { createId } from '@core/util/file';
import { DefaultFolder, Folder } from '@models/matter';

export interface FolderEditDialogData {
	author: string;
	folder?: Folder;
	parentId: string;
}

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'app-folder-edit-dialog',
	templateUrl: 'folder-edit-dialog.component.html',
	standalone: false,
})
export class FolderEditDialogComponent {
	addEdit: 'Add' | 'Rename';
	folder: Folder;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: FolderEditDialogData,
		private dialogRef: MatDialogRef<FolderEditDialogComponent>,
	) {
		this.addEdit = this.data.folder ? 'Rename' : 'Add';
		this.folder = {
			...DefaultFolder,
			...this.data.folder,
			author: this.data.author
				? this.data.author
				: this.data.folder
					? this.data.folder.author
					: DefaultFolder.author,
			createdAt: this.data.folder ? this.data.folder.createdAt : Date.now(),
			id: this.data.folder ? this.data.folder.id : createId(),
			parentId: this.data.parentId
				? this.data.parentId
				: this.data.folder
					? this.data.folder.parentId
					: DefaultFolder.parentId,
		};
	}

	cancelModal(): void {
		this.dialogRef.close();
	}

	saveFolder(): void {
		this.dialogRef.close(this.folder);
	}
}
